import React, { useEffect, useState } from "react";
import Styles from "./Styles.module.css";
import { CiSearch } from "react-icons/ci";
import DispatchOrderCard from "./DispatchOrderCard";
import { useFetchAll } from "../../../../custom/FetchApiHook";
import OrderApi from "../../../../App/api/order.apis";

const item = [];
function DispatchNavCard({ sx, tabs, setTab, allDeliveryMan,fetchAllDeliveryMan }) {
  const [search, setSearch] = useState("");
  const [clickedTab, setClickedTab] = useState({
    tab: "New"
  });
  const [pagination, setPagination] = useState({
    "page": 1,
    "limit": 5,
    "sortOrder": "desc",
    "filter": {
      "orderDetails.delivery_status": "ASSIGNED"
    },
  });
  const { value, fetchAllData } = useFetchAll(() =>
    OrderApi.getAllOrders(pagination ? pagination : {}, search)
  );

  const handleClick = (t, i) => {
    {t.tab==="Assigned" && setPagination({
      "page": 1,
        "limit": 5,
        "sortOrder": "desc",
        "filter": {"orderDetails.delivery_status": "AWAITDELIVERYMAN"}

    })}
    {t.tab==="New" && setPagination({
      "page": 1,
        "limit": 5,
        "sortOrder": "desc",
        "filter": {
          "orderDetails.delivery_status": "ASSIGNED"
        }
    })}

    console.log("tab",t);
    setClickedTab(t);
    // console.log("Index",i);
    const updatedTabs = tabs.map((item, index) => {
      if (index === i) {
        item.isActive = true;
      } else {
        item.isActive = false;
      }
      return item;
    });
    // console.log("tabs",updatedTabs);
    setTab(updatedTabs);
  };
  useEffect(() => {
    fetchAllData();
  }, [pagination]);
  console.log("order dispatch:", value?.data?.orders);

  return (
    <div style={sx ? sx : {}} className={[`${Styles.navContainer}`]}>
      <div className={[`${Styles.nav}`]}>
        {tabs.map((t, i) => (
          <button
            key={i}
            onClick={() => handleClick(t, i)}
            className={
              t.isActive
                ? [`${Styles.active} ${Styles.navItem}`]
                : [`${Styles.navItem}`]
            }
          >
            {t.tab}
          </button>
        ))}
      </div>
      <div style={{ paddingInline: "2rem" }}>
        <div className={Styles.border_search}>
          {/* <div>Search</div> */}
          <input
            type="text"
            style={{
              border: "none",
              outline: "none",
              backgroundColor: "transparent",
            }}
            // className={styles.border_search}
            placeholder="Search"
          />
          <CiSearch size={"1.1rem"} />
        </div>
        {clickedTab.tab==='New' && <div className="m-2">
        {value?.data?.orders.map((item) => (
          <DispatchOrderCard fetchAllDeliveryMan={fetchAllDeliveryMan} allDeliveryMan={allDeliveryMan} key={item.id} item={item} />
        ))}
        </div>}

      </div>
    </div>
  );
}

export default DispatchNavCard;
